<div #activeModal class="modal-header-custom">
  {{ title }}

  <h2 class="d-flex align-items-center">
    <i
      class="fa fa-exclamation text-danger"
      *ngIf="type == basicModalOperationResults.Error"
      aria-hidden="true"
    ></i>
    <i
      class="fa fa-exclamation-triangle .text-success"
      *ngIf="type == basicModalOperationResults.Warning"
      aria-hidden="true"
    ></i>
    <i
      class="fa fa-check-circle text-success"
      *ngIf="type == basicModalOperationResults.Success"
      aria-hidden="true"
    ></i>
  </h2>
</div>
<div class="modal-body">
  <p style="white-space: pre-line">{{ body }}</p>
</div>
<div class="modal-footer">
  <button
    type="button"
    *ngFor="let btn of buttons"
    [class]="btn.cssClass ? btn.cssClass : 'btn btn-outline-dark'"
    (click)="btnClicked(btn)"
    [disabled]="btn.disabled == true"
  >
    {{ btn.text }}
  </button>
</div>
